import { render, staticRenderFns } from "./dashTask.vue?vue&type=template&id=738efd10&scoped=true&"
import script from "./dashTask.vue?vue&type=script&lang=js&"
export * from "./dashTask.vue?vue&type=script&lang=js&"
import style0 from "./dashTask.vue?vue&type=style&index=0&id=738efd10&lang=scss&rel=stylesheet%2Fsass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738efd10",
  null
  
)

export default component.exports